import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';

export default function PointReasonInput(props) {
  const { value, setValue } = props;
  const { t } = useLanguage();

  function handleChange(e) {
    setValue(e.target.value);
  }

  function handleFocus() {
    
  }

  function handleBlur() {
    
  }

  return (
    <TopLevelWrapper>
      <Input 
        // ref={InputRef}
        placeholder={t('memberDetail.pointSaveModal.placeholderReason')}
        value={value || ''}
        onFocus={handleFocus}
        onChange={handleChange}
        onBlur={handleBlur}/>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const Input = styled.textarea`
  width: calc(100% - 20px);
  height: 17px;
  // height: 52px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  padding: 10px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  outline: none;

  color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

  resize: none;

  ::placeholder {
    color: ${props => props.theme.gray};
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;